import React from 'react';
import { Link } from 'react-router-dom';
import { Coins } from 'lucide-react';

export function CreditBadge({ balance, className = '' }) {
  return (
    <Link
      to="/credits"
      className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-primary/10 hover:bg-primary/15 transition-colors text-sm font-medium text-primary cursor-pointer ${className}`}
      data-testid="credit-balance-badge"
      title="View credit plans"
    >
      <Coins className="h-3.5 w-3.5" />
      <span>{balance ?? 0}</span>
      <span className="text-primary/70 text-xs">credits</span>
    </Link>
  );
}

